const calculateTotalFoodDiscounts = discounts => (
  discounts.reduce((t, discount) => {
    const { foodDiscount = 0, couponCanUsed } = discount

    if (couponCanUsed) return t += foodDiscount
    else return t += 0
  }, 0)
)

export default calculateTotalFoodDiscounts